/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_A4Inputs */

const en_guide_large_json_files_faq_a4 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDJSON, or newline-delimited JSON, stores one JSON value per line. It is ideal for logs and large exports because you can read and process it one record at a time without loading the whole file into memory.`)
};

const ko_guide_large_json_files_faq_a4 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDJSON은 줄바꿈으로 구분된 JSON으로, 한 줄에 JSON 값 하나를 저장합니다. 파일 전체를 메모리에 올리지 않고 한 레코드씩 읽어 처리할 수 있어 로그와 대용량 내보내기에 이상적입니다.`)
};

const ja_guide_large_json_files_faq_a4 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDJSON は改行区切りの JSON で、一行に一つの JSON 値を保存します。ファイル全体をメモリに載せずに一レコードずつ読んで処理できるため、ログや大規模なエクスポートに最適です。`)
};

/**
* | output |
* | --- |
* | "NDJSON, or newline-delimited JSON, stores one JSON value per line. It is ideal for logs and large exports because you can read and process it one record at a..." |
*
* @param {Guide_Large_Json_Files_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_a4 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_a4(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_a4(inputs)
	return ja_guide_large_json_files_faq_a4(inputs)
});